import { environment } from '@env/environment';

const { apiAuth, apiUrl, apiAuthProvider } = environment;

/**
 * ### **AuthenticateEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición.
 */
export class AuthenticateEndpoint {
  /** Endpoint que apunta al modulo del token autenticación que maneja el servidor*/
  static authenticate = `${apiAuth}api-token-auth/`;
  /** Endpoint que apunta al modulo que refresca el token autenticación que maneja el servidor*/
  static refreshToken = `${apiAuth}api-token-refresh/`;
  /** Endpoint que apunta al modulo del  verificación del token que maneja el servidor*/
  static verifyToken = `${apiAuth}api-token-verify/`;
  /** Endpoint que apunta a la información del usuario autenticado*/
  static getAuthInfo = `${apiUrl}users/user/`;
  /** Login con Facebook */
  static loginFacebook = `${apiAuthProvider}auth/login/facebook`;
  /** Login con Google */
  static loginGoogle = `${apiAuthProvider}auth/login/google`;
}
